import {
  faCheckSquare,
  faCircle,
  faClipboardList,
  faDotCircle,
  faDownload,
  faFilter,
  faPrint,
  faSquare,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useContext, useEffect, useRef } from 'react';
import { Button, Input, Label, Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { useAuth0 } from '../../../../../auth0/reactAuth0Spa';
import { DepartmentContext } from '../../../../../DepartmentWrapper';
import style from './PrintMaterials.style';
import { fetchCandidates } from '../../../../../Services/CandidatesAPI';
import './PrintMaterials.style.css';
import { fetchDataAgnostic, postDataAgnostic } from '../../../../../Services/dataApi';
import { checkLoginForError, formatBearerToken } from '../../../../../Common.functions';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import { CSVLink } from 'react-csv';
import dayjs from 'dayjs';
import { clone, set } from 'lodash';
import Loading from 'Body/Statuses/Loading';
import Swal from 'sweetalert2';
import { processExportCandidates } from 'Services/CSVExports';
import { createPDFForCandidateEvaluationsWithAnswers } from 'Services/PDFMakeTemplates/CandidateEvaluations/CandidateEvaluationsAnswered';
import { createPDFForMockOrals } from 'Services/PDFMakeTemplates/MockOrals/MockOrals';
import PdfPreviewModal from '../../../Coordinator/Schedule/TopBar/PdfPreviewModal';

const PrintMaterials = () => {
  const [candidates, setCandidates] = useState([]);
  const [allCandidates, setAllCandidates] = useState([]); // Store all candidates before filtering
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showCandidatePopover, setShowCandidatePopover] = useState(false);

  const [datesToProcess, setDatesToProcess] = useState(0);
  const [datesProcessed, setDatesProcessed] = useState(0);
  const [downloadType, setDownloadType] = useState('evaluation'); // evaluation or prescreen
  const [isGettingCandidateResults, setIsGettingCandidateResults] = useState(false);
  const [isProcessingDates, setIsProcessingDates] = useState();
  const [isLoadingCandidates, setIsLoadingCandidates] = useState();
  const [isProcessingMockOrals, setIsProcessingMockOrals] = useState();
  const [showPdfPreviewModal, setShowPdfPreviewModal] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const [pdfPreviewTitle, setPdfPreviewTitle] = useState('');
  const [pdfPreviewFileName, setPdfPreviewFileName] = useState('');

  const [CSVData, setCSVData] = useState([]);
  const [scaleData, setScaleData] = useState(null);

  // Filter state
  const [interviewDates, setInterviewDates] = useState([]);
  const [filterType, setFilterType] = useState('all'); // 'all', 'prescreen', or pk_InterviewDate
  const [filterLabel, setFilterLabel] = useState('All Candidates');
  const [showFilterPopover, setShowFilterPopover] = useState(false);

  const datesProcessedRef = useRef(0);

  const dContext = useContext(DepartmentContext);
  const { getTokenSilently, loginWithRedirect } = useAuth0();

  useEffect(() => {
    getCandidates();
    getScale();
    getInterviewDates();
  }, []);

  useEffect(() => {
    if (CSVData && CSVData.length > 0) {
      // CSVData.splice(0, 1);
      document.getElementById('download_actual_candidates').click();
      setShowCandidatePopover(false);
      setSelectedCandidates([]);
      setSelectAll(false);
    }
  }, [CSVData]);

  useEffect(() => {
    if (selectedCandidates) {
      if (candidates.length > 0 && selectedCandidates.length == candidates.length && !selectAll) {
        setSelectAll(true);
      } else if (selectedCandidates.length < candidates.length && selectAll) {
        setSelectAll(false);
      }
    }
  }, [selectedCandidates]);

  useEffect(() => {
    return () => {
      if (pdfPreviewUrl) {
        URL.revokeObjectURL(pdfPreviewUrl);
      }
    };
  }, [pdfPreviewUrl]);

  // Apply filter when filterType changes
  useEffect(() => {
    applyFilter();
  }, [filterType, allCandidates]);

  const applyFilter = () => {
    if (filterType === 'all') {
      setCandidates(allCandidates);
    } else if (filterType === 'prescreen') {
      // Filter candidates who have prescreen data (you may need to adjust this logic)
      setCandidates(allCandidates.filter((c) => c.PrescreenScoreAsDecimal != null));
    } else {
      // Filter by specific interview date (filterType is pk_InterviewDate)
      setCandidates(allCandidates.filter((c) => c.pk_InterviewDate == filterType));
    }
  };

  const handleFilterChange = (type, label) => {
    setFilterType(type);
    setFilterLabel(label);
    setShowFilterPopover(false);
    setSelectedCandidates([]); // Clear selections when filter changes
    setSelectAll(false);
  };

  const getCandidates = () => {
    if (dContext.department) {
      setIsLoadingCandidates(true);
      getTokenSilently()
        .then((token) => {
          fetchCandidates(token, {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            callback: (newCandidates) => {
              setIsLoadingCandidates(false);
              const filteredCandidates = Object.values(newCandidates).filter((c) => {
                return !c.isRemoved && !c.isDeleted;
              });
              setAllCandidates(filteredCandidates);
              setCandidates(filteredCandidates);
            },
          });
        })
        .catch((err) => {
          checkLoginForError({ err, loginWithRedirect });
        });
    } else {
      setTimeout(getCandidates);
    }
  };

  const getInterviewDates = () => {
    if (dContext.department) {
      getTokenSilently()
        .then((token) => {
          fetchDataAgnostic(
            'department/interviewDates',
            { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
            formatBearerToken(token),
          )
            .then((res) => {
              if (res.data && Array.isArray(res.data)) {
                setInterviewDates(
                  res.data.sort((a, b) => {
                    const dateA = dayjs(`${a.DateOfInterview} ${a.StartTime}`).valueOf();
                    const dateB = dayjs(`${b.DateOfInterview} ${b.StartTime}`).valueOf();
                    return dateA - dateB;
                  }),
                );
              }
            })
            .catch((err) => {
              checkLoginForError({ err, loginWithRedirect });
            });
        })
        .catch((err) => {
          checkLoginForError({ err, loginWithRedirect });
        });
    }
  };

  const getScale = (scale) => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/questions',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            setScaleData(res.data);
          })
          .catch((err) => {
            console.log('getScale err: ', err);
          })
          .finally(() => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getCandidateResults = (options) => {
    const { callback } = options;
    setIsGettingCandidateResults(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/season/mockorals/responses/all',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
          },
          {
            pk_Candidates: selectedCandidates || [],
            type: 'evaluation',
          },
          formatBearerToken(token),
        )
          .then((res) => {
            if (callback) {
              callback(res.data);
              return;
            }

            setIsGettingCandidateResults(false);
          })
          .catch((err) => {
            console.log('err1: ', err);
            if (callback) {
              callback();
            }

            setIsGettingCandidateResults(false);
          });
      })
      .catch((err) => {
        console.log('err2: ', err);
        if (callback) {
          callback();
        }
        setIsGettingCandidateResults(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getUserEvaluations = (type, callback) => {
    setIsGettingCandidateResults(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/season/evaluation/responses/all',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
          },
          {
            type,
            groupBy: 'user',
            pk_Candidates: selectedCandidates || [],
          },
          formatBearerToken(token),
        )
          .then((res) => {
            setIsGettingCandidateResults(false);
            if (callback) {
              callback({ items: res.data || [], type });
              return;
            }
            const newData = processExportCandidates({ items: res.data, type });

            if (newData) {
              setCSVData(newData);
            }
          })
          .catch((err) => {
            console.log('getUserEvaluations err: ', err);
            setIsGettingCandidateResults(false);
            if (callback) {
              callback({ items: [], type });
            }
          });
      })
      .catch((err) => {
        setIsGettingCandidateResults(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const processExportPDF = (options) => {
    const { items, type } = options;
    const { department } = dContext;
    if (items.length <= 0) {
      Swal.fire('Error', 'There are no reports available for any of the selected candidates!', 'error');
      return;
    }

    if (!scaleData) {
      Swal.fire('Error', 'There is no Question data to print!', 'error');
      return;
    }
    createPDFForCandidateEvaluationsWithAnswers({
      department,
      evaluators: items,
      type,
      scaleData,
      emptyMessage: 'There are no reports available for any of the selected candidates!',
      previewCallback: handlePdfPreviewReady(`Candidate Evaluations - ${filterLabel}`),
    });
  };

  const closePdfPreviewModal = () => {
    setShowPdfPreviewModal(false);
    if (pdfPreviewUrl) {
      URL.revokeObjectURL(pdfPreviewUrl);
    }
    setPdfPreviewUrl(null);
    setPdfPreviewTitle('');
    setPdfPreviewFileName('');
  };

  const handlePdfPreviewReady = (title) => {
    return (blobUrl, fileName, err) => {
      setIsGettingCandidateResults(false);

      if (err || !blobUrl) {
        return;
      }

      if (pdfPreviewUrl) {
        URL.revokeObjectURL(pdfPreviewUrl);
      }

      setPdfPreviewUrl(blobUrl);
      setPdfPreviewTitle(title);
      setPdfPreviewFileName(fileName || `${title}.pdf`);
      setShowPdfPreviewModal(true);
    };
  };

  const renderCandidateEvaluations = () => {
    const { AllowPrescreen = false } = dContext && dContext.season ? dContext.season : {};

    return (
      <div style={style.simpleColumn}>
        {/* Filter Button */}
        <div style={{ ...style.simpleRow, justifyContent: 'center', marginTop: 10, marginBottom: 5 }}>
          <Button
            id="filterButton"
            color="primary"
            outline
            onClick={() => setShowFilterPopover(!showFilterPopover)}
            style={{ minWidth: 200 }}
          >
            {filterLabel} <FontAwesomeIcon icon={faFilter} style={{ marginLeft: 8 }} />
          </Button>
          <Popover
            placement="bottom"
            isOpen={showFilterPopover}
            target="filterButton"
            toggle={() => setShowFilterPopover(false)}
            trigger="legacy"
            style={{ maxWidth: 350 }}
          >
            <PopoverHeader>Filter Candidates</PopoverHeader>
            <PopoverBody style={{ maxHeight: 400, overflowY: 'auto', padding: 10 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                {/* All Candidates Option */}
                <Button
                  color={filterType === 'all' ? 'primary' : 'secondary'}
                  outline={filterType !== 'all'}
                  onClick={() => handleFilterChange('all', 'All Candidates')}
                  style={{ textAlign: 'left' }}
                >
                  All Candidates
                </Button>

                {/* Prescreen Option - only if AllowPrescreen is enabled */}
                {AllowPrescreen && (
                  <Button
                    color={filterType === 'prescreen' ? 'primary' : 'secondary'}
                    outline={filterType !== 'prescreen'}
                    onClick={() => handleFilterChange('prescreen', 'Prescreen')}
                    style={{ textAlign: 'left' }}
                  >
                    Prescreen
                  </Button>
                )}

                {/* Interview Date Options */}
                {interviewDates.map((date) => {
                  const dateLabel = dayjs(`${date.DateOfInterview} ${date.StartTime}`).format('MMM DD, YYYY');
                  const fullLabel = date.Label ? `${dateLabel} (${date.Label})` : dateLabel;
                  const isSelected = filterType == date.pk_InterviewDate;

                  return (
                    <Button
                      key={date.pk_InterviewDate}
                      color={isSelected ? 'primary' : 'secondary'}
                      outline={!isSelected}
                      onClick={() => handleFilterChange(date.pk_InterviewDate, fullLabel)}
                      style={{ textAlign: 'left' }}
                    >
                      {fullLabel}
                    </Button>
                  );
                })}
              </div>
            </PopoverBody>
          </Popover>
        </div>

        <div style={{ ...style.simpleRow, justifyContent: 'center', marginTop: 5 }}>
          <div
            style={{
              ...style.simpleColumn,
              width: '80%',
              minWidth: 300,
            }}
          >
            {/* Table Header */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                padding: 10,
                backgroundColor: '#4a5568',
                color: 'white',
                fontWeight: 'bold',
                borderBottom: '2px solid #2d3748',
              }}
            >
              <div
                style={{
                  width: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (!selectAll) {
                    setSelectedCandidates(
                      candidates.map((c) => {
                        return c.pk_Candidate;
                      }),
                    );
                  } else if (candidates.length > 0 && selectedCandidates.length === candidates.length) {
                    setSelectedCandidates([]);
                  }
                  setSelectAll(!selectAll);
                }}
              >
                <FontAwesomeIcon icon={selectAll ? faCheckSquare : faSquare} />
              </div>
              <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>Candidate</div>
              <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>Interview Session</div>
            </div>

            {/* Table Body */}
            <div
              style={{
                overflowY: 'scroll',
                height: `calc(100vh - 410px)`,
              }}
            >
              {isLoadingCandidates ? (
                <div style={{ fontWeight: 'bold', width: '100%', marginTop: 100, textAlign: 'center' }}>
                  Loading. . .
                </div>
              ) : candidates && candidates.length > 0 ? (
                candidates
                  .sort((a, b) => {
                    const stringA = `${a.LastName || ''} ${a.LastName ? ', ' : ''}${a.FirstName}`;
                    const stringB = `${b.LastName || ''} ${b.LastName ? ', ' : ''}${b.FirstName}`;
                    if (stringA < stringB) {
                      return -1;
                    }
                    if (stringA > stringB) {
                      return 1;
                    }
                    return 0;
                  })
                  .map((c, i) => {
                    const isSelected = selectedCandidates.includes(c.pk_Candidate);
                    const candidateName = `${c.LastName || ''}${c.LastName ? ', ' : ''}${c.FirstName || ''}`;

                    // Format interview session
                    let interviewSession = '';
                    if (c.DateOfInterview && c.InterviewStartTime) {
                      const formattedDate = dayjs(`${c.DateOfInterview} ${c.InterviewStartTime}`).format(
                        'dddd MMMM DD, YYYY',
                      );
                      interviewSession = c.Label ? `${formattedDate} (${c.Label})` : formattedDate;
                    }

                    return (
                      <div
                        key={c.pk_Candidate}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          padding: 10,
                          cursor: 'pointer',
                          backgroundColor: isSelected ? '#d9f5ff' : i % 2 == 0 ? '#c7cbd1' : 'white',
                          borderBottom: '1px solid #e2e8f0',
                        }}
                        onClick={() => {
                          const newCandidates = selectedCandidates.slice();
                          if (isSelected) {
                            newCandidates.splice(newCandidates.indexOf(c.pk_Candidate), 1);
                          } else {
                            newCandidates.push(c.pk_Candidate);
                          }
                          setSelectedCandidates(newCandidates);
                        }}
                      >
                        <div style={{ width: '50px', display: 'flex', alignItems: 'center' }}>
                          <FontAwesomeIcon icon={isSelected ? faCheckSquare : faSquare} />
                        </div>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', textAlign: 'left' }}>
                          {candidateName}
                        </div>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', textAlign: 'left' }}>
                          {interviewSession}
                        </div>
                      </div>
                    );
                  })
              ) : (
                <div style={{ fontWeight: 'bold', width: '100%', marginTop: 100, textAlign: 'center' }}>
                  No Candidates
                </div>
              )}
            </div>
          </div>
        </div>
        <div style={{ ...style.simpleRow, justifyContent: 'center', marginTop: 10 }}>
          <div style={{ ...style.simpleColumn, width: '80%' }}>
            <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
              {AllowPrescreen ? (
                <>
                  <Button
                    color="primary"
                    size="sm"
                    disabled={selectedCandidates.length <= 0 || isGettingCandidateResults}
                    style={{ width: '100%', marginRight: 10 }}
                    onClick={() => {
                      setDownloadType('prescreen');
                      getUserEvaluations('prescreen');
                    }}
                  >
                    <div style={style.spacedBetweenRow} id="exportCompleted">
                      <div>
                        <FontAwesomeIcon icon={faDownload} />
                      </div>
                      <div style={{ ...style.centeredText, fontSize: 15 }}>Prescreen Data (CSV)</div>
                    </div>
                  </Button>
                  <Button
                    color="primary"
                    size="sm"
                    disabled={selectedCandidates.length <= 0 || isGettingCandidateResults}
                    style={{ width: '100%', marginRight: 10 }}
                    onClick={() => {
                      setDownloadType('prescreen');
                      getUserEvaluations('prescreen', processExportPDF);
                    }}
                  >
                    <div style={style.spacedBetweenRow} id="exportCompleted">
                      <div>
                        <FontAwesomeIcon icon={faDownload} />
                      </div>
                      <div style={{ ...style.centeredText, fontSize: 15 }}>Prescreen PDF</div>
                    </div>
                  </Button>
                </>
              ) : null}

              <Button
                color="primary"
                size="sm"
                disabled={selectedCandidates.length <= 0 || isGettingCandidateResults}
                style={{ width: '100%', marginRight: 10 }}
                onClick={() => {
                  setDownloadType('evaluation');
                  getUserEvaluations('evaluation');
                }}
              >
                <div style={style.spacedBetweenRow} id="exportCompleted">
                  <div>
                    <FontAwesomeIcon icon={faDownload} />
                  </div>
                  <div style={{ ...style.centeredText, fontSize: 15 }}>Evaluation Data (CSV)</div>
                </div>
              </Button>

              <Button
                color="primary"
                size="sm"
                disabled={selectedCandidates.length <= 0 || isGettingCandidateResults}
                style={{ width: '100%', marginRight: 10 }}
                onClick={() => {
                  setDownloadType('evaluation');
                  getUserEvaluations('evaluation', processExportPDF);
                }}
              >
                <div style={style.spacedBetweenRow} id="exportCompleted">
                  <div>
                    <FontAwesomeIcon icon={faDownload} />
                  </div>
                  <div style={{ ...style.centeredText, fontSize: 15 }}>Evaluation PDF</div>
                </div>
              </Button>

              {dContext.department && dContext.department.ProgramType === 'Mock Oral Board' ? (
                <Button
                  color="primary"
                  size="sm"
                  disabled={selectedCandidates.length <= 0 || isGettingCandidateResults}
                  style={{ width: '100%', marginRight: 10 }}
                  onClick={() => {
                    setDownloadType('evaluation');
                    setIsGettingCandidateResults(true);
                    getCandidateResults({
                      callback: (rawData) => {
                        setIsGettingCandidateResults(false);

                        createPDFForMockOrals({
                          rawData,
                          scaleData,
                          department: dContext.department,
                          candidates: selectedCandidates
                            .map((c) => {
                              const matchingCandidate = rawData.Candidates.find((c2) => {
                                return c2.pk_Candidate === c;
                              });

                              const matchingCandidate2 = candidates.find((c2) => {
                                return c2.pk_Candidate === c;
                              });
                              const matchingCandidateDate = matchingCandidate2
                                ? matchingCandidate2.DateOfInterview
                                : null;
                              if (matchingCandidate) {
                                return { ...matchingCandidate, DateOfInterview: matchingCandidateDate };
                              }
                            })
                            .filter((c) => c !== undefined),
                          callback: () => {
                            setIsGettingCandidateResults(false);
                          },
                        });
                      },
                    });
                  }}
                >
                  <div style={style.spacedBetweenRow} id="exportCompleted">
                    <div>
                      <FontAwesomeIcon icon={faDownload} />
                    </div>
                    <div style={{ ...style.centeredText, fontSize: 15 }}> Mock Orals PDF</div>
                  </div>
                </Button>
              ) : null}
            </div>
          </div>

          {/* <Button
            disabled={selectedCandidates.length <= 0 || isGettingCandidateResults}
            color="primary"
            style={{ width: 150, marginTop: 15 }}
            onClick={() => {
              getCandidateResults();
            }}
          >
            Print
          </Button> */}
        </div>
      </div>
    );
  };

  const renderLoadingModal = () => {
    return (
      <Modal isOpen={isProcessingDates} centered={true}>
        <ModalBody>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <Loading
              options={{
                labelText: `Processing interview dates: ${
                  datesToProcess ? `${datesProcessedRef.current} / ${datesToProcess}` : '. . .'
                }`,
              }}
            />
          </div>
        </ModalBody>
      </Modal>
    );
  };

  const renderMockOralLoadingModal = () => {
    return (
      <Modal isOpen={isGettingCandidateResults} centered={true}>
        <ModalBody>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <Loading
              options={{
                labelText: `Processing candidates. . .`,
                labelStyle: { fontSize: 9, textAlign: 'center', fontWeight: 'bold' },
              }}
            />
          </div>
        </ModalBody>
      </Modal>
    );
  };

  return (
    <div>
      <div style={style.simpleRow}>
        {renderCandidateEvaluations()}
        {renderLoadingModal()}
        {renderMockOralLoadingModal()}
        <PdfPreviewModal
          isOpen={showPdfPreviewModal}
          title={pdfPreviewTitle}
          pdfUrl={pdfPreviewUrl}
          fileName={pdfPreviewFileName}
          onClose={closePdfPreviewModal}
        />
        <div style={{ visibility: 'hidden' }}>
          <CSVLink
            data={CSVData}
            target="_blank" rel="noopener noreferrer"
            id={`download_actual_candidates`}
            filename={`Export_Candidates_Evaluations_(${downloadType})_${dayjs().format('MMM DD, YYYY hhmm A')}`}
          />
        </div>
      </div>
    </div>
  );
};

export default PrintMaterials;
